<template>
    <div class="dialogWrap">
        <!--未实名提示 -->
        <el-dialog
            title="提示"
            :visible.sync="noRealName"
            width="380px"
            top="27vh"
            class="myDialog"
            center
            :before-close="close"
            :close-on-click-modal="false"
        >
            <div class="dialog-content-center">你需要先完成账号的实名认证。</div>
            <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="$router.push('/userCenter/AuthenticationName')">去认证</el-button>
                <el-button round class="next" @click="close">取消</el-button>
            </span>
        </el-dialog>

        <!-- 验证手机号 -->
        <el-dialog
            title="通过手机号验证"
            :visible.sync="realPhone"
            width="480px"
            top="27vh"
            class="myDialog"
            center
            :before-close="close"
            :close-on-click-modal="false"
        >
            <p class="warning">
                <i class="el-icon-warning"></i>
                &nbsp;&nbsp;&nbsp;&nbsp;请务必提供真实信息，公司有权委托第三方，审查提供的身份信息是否真实、有效。若提供虚假信息，由此带来的后果由提供方承担。
            </p>
            <el-row :gutter="20" type="flex" class="row-bg" justify="center">
                <el-col :span="20">
                    <p class="tips">真实姓名：{{ userInfo.name }}</p>
                    <p class="tips">证件号码：{{ userInfo.idCard }}</p>
                    <el-form
                        :model="verifyPhoneForm"
                        status-icon
                        :rules="rulesPhone"
                        ref="verifyPhoneForm"
                        label-width="0px"
                        class="demo-ruleForm"
                    >
                        <el-form-item prop="phone" :error="accountError">
                            <el-input
                                type="text"
                                v-model="verifyPhoneForm.phone"
                                autocomplete="off"
                                clearable
                                placeholder="请输入您的手机号"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="code" :error="codeError">
                            <el-input
                                type="text"
                                v-model="verifyPhoneForm.code"
                                autocomplete="off"
                                clearable
                                placeholder="请输入验证码"
                                class="codeIpt"
                            >
                                <span class="yzm" slot="append" :disabled="disabled" @click="getVerificationCode">
                                    {{ yzmtext }}
                                </span>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <p class="agreement" v-if="type==1">
                <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
                <a :href="realNameAgreement" target="_blank">《实名认证服务协议》</a>
            </p>
            <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="handlPhoneVerify('verifyPhoneForm')">提交验证</el-button>
                <el-button round class="next" @click="close">取消</el-button>
            </span>
        </el-dialog>

        <!-- 换绑邮箱 -->
        <el-dialog
            :title="type==1?'绑定新邮箱':'预绑定新邮箱'"
            :visible.sync="bindEmail"
            width="480px"
            top="27vh"
            class="myDialog"
            center
            :before-close="close"
            :close-on-click-modal="false"
        >
            <el-row :gutter="20" type="flex" class="row-bg" justify="center">
                <el-col :span="20">
                    <p class="tips" v-if="type==2">请填写要绑定的新邮箱号，审核通过后将自动完成换绑</p>
                    <el-form
                        :model="changeBindEmailForm"
                        status-icon
                        :rules="rulesEmail"
                        ref="changeBindEmailForm"
                        label-width="0px"
                        class="demo-ruleForm"
                    >
                        <el-form-item prop="account" :error="accountError">
                            <el-input
                                type="text"
                                v-model="changeBindEmailForm.account"
                                autocomplete="off"
                                clearable
                                placeholder="请输入要绑定的邮箱"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="code" :error="codeError">
                            <el-input
                                type="text"
                                v-model="changeBindEmailForm.code"
                                autocomplete="off"
                                clearable
                                placeholder="请输入验证码"
                                class="codeIpt"
                            >
                                <span class="yzm" slot="append" :disabled="disabled" @click="getVerificationCode">
                                    {{ yzmtext }}
                                </span>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="handlBindSub('changeBindEmailForm')">绑定</el-button>
                <el-button round class="next" @click="close">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { identification } from "@http/user_center/userInfo";
import { sendMsg,verifyPhoneAuthentication,emailByAuthentication,changeBindApply,refreshToken} from "@http/userCenter/index";
import NoTrace from '@/utils/noTrace';
let interval = null;
let time = 61;
export default {
    name: 'ChangeEmail',
    data () {
        var vPhone = (rule, value, callback) => {
            if (!/^1[23456789]\d{9}$/.test(value)) {
                callback(new Error("手机号格式不正确"));
            }
            callback();
        };
        var vAccount = (rule, value, callback) => {
            var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
            if (!reg.test(value)) {
                callback(new Error("邮箱号格式不正确"));
            }
            callback();
        };
        var vCode = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入验证码"));
            }
            if (value.trim().length == 0) {
                callback(new Error("验证码不能为空"));
            }
            callback();
        };
        return {
            realNameAgreement:process.env.VUE_APP_USERCENTERUI+'/agreement/realNameProtocol',
            noRealName: false,
            realPhone:false,
            bindEmail:false,
            userInfo:{},
            authenticationStatus:'',
            type:'',
            authId:'',//手机三要素返回的id
            yzmtext: "获取验证码",
            disabled: false,
            currentTime: 61,
            checked: false,//是否阅读协议
            // 验证手机号后换绑邮箱
            verifyPhoneForm:{
                phone:'',
                code:'',
                clientId:this.$getlocalStorage("queryData")? this.$getlocalStorage("queryData").clientId: "",
            },
            rulesPhone:{
                phone:[{ validator: vPhone }],
                code: [{ validator: vCode }],
            },
            // 个人用户换绑
            changeBindEmailForm:{
                account:'',
                type:'',
                code:'',
                clientId:this.$getlocalStorage("queryData")? this.$getlocalStorage("queryData").clientId: "",
            },
            rulesEmail:{
                code: [{ validator: vCode }],
                account: [{ validator: vAccount }],
            },
            accountError:'',
            codeError:'',
        }
    },
    components: {},
    computed: {},
    created() {
        this.init();
    },
    mounted() {},
    methods: {
        close(){
            this.noRealName=false;
            this.bindEmail=false;
            this.realPhone=false;
            this.$emit('closeProcess')
        },
        init(){
            let that = this;
            identification({hiddenApproval:true}).then((res) => {
                that.authenticationStatus = res.authenticationStatus;//对应的值看AuthenticationName页注释
                that.type = res.type;
                //未实名认证的状态
                if([-1,3,5].includes(res.authenticationStatus)){
                    that.noRealName=true;
                    return
                }
                if(res.type==2){
                    that.userInfo=res.enterprise;
                    that.bindEmail=true;
                }else{
                    that.userInfo=res.personal
                    that.realPhone=true;
                }
                that.resetYzm(0);
            }).catch((err) => {
                console.log(err);
            });
        },
        getVerificationCode() {
            this.accountError=null;
            if (this.realPhone && !/^1[23456789]\d{9}$/.test(this.verifyPhoneForm.phone)) {
                this.accountError="请输入正确的手机号"
                return false;
            }
            if (this.bindEmail && !new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$").test(this.changeBindEmailForm.account)) {
                this.accountError="请输入正确格式的邮箱"
                return false;
            }

            this.getCode();
            this.disabled = true;
            // this.realPhone && this.$refs.Verification2.getNvc();
            // this.bindEmail && this.$refs.Verification3.getNvc();
            // 开始获取无痕验证码
            NoTrace.start((nvc) => {
                this.nvc = nvc
            }, this.executeFun, {
                loginName: this.bindEmail ? this.changeBindEmailForm.account : this.verifyPhoneForm.phone,
                signupType: this.bindEmail ? "EMAIL" : "PHONE",
                nvc: '',
                afsVersion: 2
            })
        },
        executeFun (params) {
            let that=this;
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await sendMsg(params);
                    resolve(res)
                    that.$msg("验证码已发送，请注意接收", "success");
                }catch (err) {
                    reject(err)
                    that.resetYzm();
                    that.$msg(err.message);
                }
            })
        },
        getCode() {
            var that = this;
            var currentTime = that.currentTime;
            interval = setInterval(function() {
                currentTime--;
                that.yzmtext = "(" + currentTime + "s)重新获取";
                if (currentTime <= 0) {
                    that.resetYzm();
                }
            }, 1000);
        },
        //提交手机号验证
        handlPhoneVerify(verifyPhoneForm){
            let that = this;
            this.$refs[verifyPhoneForm].validate((valid) => {
                if(!that.checked && that.type==1){
                    that.$msg("请先阅读并勾选协议");
                    return false;
                }
                if (valid) {
                    that.codeError = null;
                    that.accountError = null;
                    verifyPhoneAuthentication(this.verifyPhoneForm).then((res) => {
                        that.authId=res.id;
                        that.$refs["verifyPhoneForm"].resetFields();
                        that.$refs["verifyPhoneForm"].clearValidate();
                        that.realPhone=false;
                        that.resetYzm(0);
                        that.bindEmail=true;
                    }).catch((err) => {
                        if (err.code == 1) { //验证码错误
                            that.codeError = err.message;
                        }else if (err.code ==999) {//4要素失败
                            that.accountError = err.message;
                        }else{
                            that.$msg(err.message);
                        }
                    });
                }
            })
        },
        //提交绑定邮箱信息
        handlBindSub(changeBindEmailForm){
            let that = this;
            this.$refs[changeBindEmailForm].validate((valid) => {
                if (valid) {
                    that.codeError = null;
                    that.accountError = null;
                    let {account,code,clientId}=that.changeBindEmailForm;
                    if(that.type==1){ //个人
                        emailByAuthentication({
                            "email": account,
                            "code": code,
                            "authId": that.authId
                        }).then((res) => {
                            that.resetYzm(0)
                            let redirectUrl = that.$getlocalStorage("queryData") ? that.$getlocalStorage("queryData").redirectUrl: "";
                            if (redirectUrl) {
                                localStorage.removeItem("queryData");
                                window.location.href =decodeURI(redirectUrl)
                            }else{
                                that.$emit('updateUserInfo')
                                that.close();
                            }
                        }).catch((err) => {
                            if (err.code == 1) { //验证码错误
                                that.codeError = err.message;
                            }else if (err.code == 2) {//已绑定其它账号
                                that.accountError = err.message;
                            }else{
                                that.$msg(err.message);
                            }
                        });
                    }else{ //企业
                        changeBindApply({
                            account,
                            code,
                            clientId,
                            type:1 //0手机号 1邮箱
                        }).then((res) => {
                            that.close();
                            that.resetYzm(0);
                            that.$router.push('/userCenter/changeBindApply?type=1')
                        }).catch((err) => {
                            if (err.code == 1) { //验证码错误
                                that.codeError = err.message;
                            }else if (err.code == 2) {//已绑定其它账号
                                that.accountError = err.message;
                            }else{
                                that.$msg(err.message);
                            }
                        });
                    }
                }
            })

        },
        resetYzm(btnStatus=1){
            this.disabled = false;
            interval && clearInterval(interval);
            this.yzmtext = btnStatus==0?"获取验证码":'重新获取';
            this.currentTime = time;
        },
    },
}

</script>
<style src="@/assets/css/dialog.less" scoped lang='less'></style>
<style scoped lang='less'>
.warning{
    color:#F09135!important;
    font-size: 14px;
}
</style>
